import { UserController } from '../services/user/controller'
import { Countries } from './countries'

class ServicesVars {
  static init() {
    self.repositories = {}
    self.servicesVars = ServicesVars
  }

  static async getUserData() {
    const user = await UserController.getUserData()
    return user
  }

  static async getUserReference() {
    const user = await UserController.getUserData()
    return user?.getReference() || ''
  }

  static async getUserCountryPrefix() {
    const user = await UserController.getUserData()
    const phone = user?.getPhoneNumber() || ''
    return phone.replace(/^(...).+/, '$1')
  }

  static async getUserCountryCode() {
    const user = await UserController.getUserData()
    const phone = user?.getPhoneNumber()
    return Countries.getPhoneCountry(phone)?.countryCode || ''
  }

  static async getUserIsConnected() {
    const user = await UserController.getUserData()
    return !!user
  }
}

export { ServicesVars }
